import moment from 'moment';

const priceFormat = (price: number): string => {
	return price.toLocaleString('en-US', {
		style: 'currency',
		currency: 'USD',
	});
};

export { dateFormat, priceFormat };

const dateFormat = (dateStr: any, time?:boolean) => {
	if (dateStr) {
		const date = dateStr ? new Date(Number(dateStr)) : new Date(); // Current date

		const formattedDate = moment(date).format('Do MMM YYYY');
		const formattedtime = moment(date).format('MMM Do YYYY, HH:mm:ss a');
		if(time){
			return formattedtime;
		}
	return formattedDate;
	} else {
		return '';
	}
};

export const dateFormatSubscription = (dateStr: any, format?: any) => {
	const date = dateStr ? new Date(dateStr) : new Date(); // Create Date object directly from the string
	const formattedDate = moment(date).format('DD MMM YYYY'); // Format the date using moment.js
	return formattedDate;
};

export const formatTime = (time: number): string => {
	const minutes = Math.floor(time / 60);
	const seconds = time % 60;
	return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

export const isNullUndefined = (value :any ) => {
	return value === undefined || value === null ;

};
